<template>
		<div class="course-list">
			<div class="sub-head">
				<div class="course-title">学习记录</div>
				<div class="subject">
					<div class="tab" v-for="(item,index) in tabList" :key="index" :class="actTab==item.id?'actTab':''" @click="getSubject(item.id)">{{item.name}}</div>
				</div>
				<div>|</div>
				<div class="subject">
					<div class="tab" :class="actType==1?'actTab':''" @click="getType(1)">课程</div>
					<div class="tab" :class="actType==2?'actTab':''" @click="getType(2)">练习</div>
					<div class="tab" :class="actType==3?'actTab':''" @click="getType(3)">考试</div>
				</div>
			</div>	
			<div class="course-cont">
				<div class="course-card" @click="goDetail(item)" v-for="(item,index) in historyList" :key="index">
<!-- 					<div class="course-bg" :style="{backgroundImage:`url(${item.coverImg})`}"> -->
						<!-- <div v-if="item.isContinue" class="course-study">继续学习</div> -->
<!-- 						<img v-if="item.ruo" class="course-ruo" src="../assets/ruo-icon.png" alt="" />
					</div> -->
					<div class="course-name">{{item.businessName||item.pointName}}</div>
					<div class="course-name">{{item.updateTime}}</div>
<!-- 					<div class="course-text">{{item.point_info}}</div> -->
<!-- 					<div class="course-btn">
						<img class="course-avator" :src="item.avator" alt="" />
						<span class="course-teacher">{{item.teacher}}</span>
						<div class="course-save"></div>
					</div> -->
				</div>
			</div>
		</div>
</template>
<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {
			actTab:1,
			actType:1,
			userInfo:JSON.parse(localStorage.getItem('userInfo')),
			historyList:[
			],
			tabList:[
				{
					id:1,
					name:'数学'
				},
				{
					id:2,
					name:'英语'
				},
				{
					id:3,
					name:'物理'
				},
			]
		}
	},

	created(){
		// this.setTab();
		if(!this.actTab){
			this.$message('当前没有学习权限，请联系老师')
			return;
		}
		this.getLearnList();
	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {
		// setTab(){
		// 	if(this.userInfo.authIds.indexOf(2)!=-1&&localStorage.getItem("schoolType") == "C"){//初中数学
		// 		this.tabList.push({
		// 			id:1,
		// 			name:'数学'
		// 		})
		// 		this.actTab = 1;
		// 	}
		// 	if(this.userInfo.authIds.indexOf(1)!=-1&&localStorage.getItem("schoolType") == "C"){//初中英语
		// 		this.tabList.push({
		// 			id:2,
		// 			name:'英语'
		// 		})
		// 		if(!this.actTab){
		// 			this.actTab = 2;
		// 		}
		// 	}
		// 	if(this.userInfo.authIds.indexOf(4)!=-1&&localStorage.getItem("schoolType") == "G"){//高中数学
		// 		this.tabList.push({
		// 			id:1,
		// 			name:'数学'
		// 		})
		// 		this.actTab = 1;
		// 	}
		// 	if(this.userInfo.authIds.indexOf(3)!=-1&&localStorage.getItem("schoolType") == "G"){//高中英语
		// 		this.tabList.push({
		// 			id:2,
		// 			name:'英语'
		// 		})
		// 		if(!this.actTab){
		// 			this.actTab = 2;
		// 		}
		// 	}
		// },
		setTab(){
			if(this.actTab == 1){
				if(this.userInfo.authIds.indexOf(3)==-1&&localStorage.getItem("schoolType") == "C"){//初中数学
					return '未开通初中数学内容'
				}
				if(this.userInfo.authIds.indexOf(4)==-1&&localStorage.getItem("schoolType") == "G"){//高中数学
					return '未开通高中数学内容'
				}
			}else if(this.actTab == 2){
				if(this.userInfo.authIds.indexOf(1)==-1&&localStorage.getItem("schoolType") == "C"){//初中英语
					return '未开通初中英语内容'
				}
				if(this.userInfo.authIds.indexOf(2)==-1&&localStorage.getItem("schoolType") == "G"){//高中英语
					return '未开通高中英语内容'
				}
			}else if(this.actTab == 3){
				if(this.userInfo.authIds.indexOf(5)==-1&&localStorage.getItem("schoolType") == "C"){//初中物理
					return '未开通初中物理内容'
				}
				if(this.userInfo.authIds.indexOf(6)==-1&&localStorage.getItem("schoolType") == "G"){//高中物理
					return '未开通高中物理内容'
				}
			}
			return false
		},
		async getLearnList(){
			const res = await this.$api.getLearnList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:this.actType,
				isComplete:false
			});
			if (res.data.success) {
				this.historyList = res.data.data;
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		goDetail(item){
			let msg = this.setTab();
			if(msg){
				this.$message.warning(msg);
				return;
			}
			// console.dir(qfurl)
			// if(qfurl){
			// 	this.showIframe = true;
			// 	this.iframeSrc = qfurl;
			// }else{
				if(this.actType==1){
					this.$router.push({  //核心语句
					  path:'/courseDetail',   //跳转的路径
					  query:{
						  id:item.pointId,
							name:item.pointName,
						  subject:this.actTab,
					  }
					})
				}else if(this.actType==2){
					this.$router.push({  //核心语句
					  path:'/testDetail',   //跳转的路径
					  query:{
							id:item.id||item.pointId,
							point_name:item.pointName,
							subject:this.actTab,
						}
					})
				}else{
					this.$emit('update-active', 3);
					this.$router.push({  //核心语句
					  path:'/exam',   //跳转的路径
					  query:{
							type:'home',
							item:JSON.stringify(item)
						}
					})
				}
			// }
		},
		
		getSubject(i){
			this.actTab = i;
			this.getLearnList();
		},
		getType(i){
			this.actType = i;
			this.getLearnList();
		},
	}
}
</script>

<style lang="scss" scoped>
.course-list{
	padding: 2.5rem 3rem;
	.sub-head{
		margin-bottom: 1.25rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-left: 0.75rem;
		.course-title{
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.6rem;
			color: #000000;
			line-height: 1.7rem;
		}
		.course-more{
			display: flex;
			align-items: center;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.2rem;
			color: rgba(0,0,0,0.8);
			line-height: 1.41rem;
			img{
				width: 1.4rem;
				height: 1.4rem;
			}
		}
		.subject{
			display: flex;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.4rem;
			color: #000000;
			line-height: 1.64rem;
			margin-right: 1.5rem;
			.tab{
				width: 5.5rem;
				height: 2.5rem;
				line-height: 2.5rem;
				text-align: center;
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				margin-left: 3rem;
			}
			.actTab{
				background: rgb(100, 45, 113);
				color: #fff;
			}
		}
	}
	.course-cont{
		// display: flex;
		// flex-wrap: wrap;
		// justify-content: flex-start;
		max-height: 45rem;
		overflow: auto;
		.course-card{
			// width: 18.35rem;
			// height: 13.45rem;
			background: #FFFFFF;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			margin: 1rem 1.7rem;
			border: 1px solid #ccc;
			overflow: hidden;
			padding: .5rem 0;
			display: flex;
			justify-content: space-between;
			.course-bg{
				width: 18.35rem;
				height: 7.5rem;
				background-repeat: no-repeat;
				background-size: cover;
				position: relative;
				.course-study{
					position: absolute;
					top: 0.75rem;
					left: 0.75rem;
					width: 4.35rem;
					height: 1.8rem;
					background: rgba(141,51,0,0.77);
					border-radius: 3rem 3rem 3rem 3rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: rgb(100, 45, 113);
					line-height: 1.8rem;
					text-align: center;
				}
				.course-ruo{
						position: absolute;
						right: 0;
						top: 0;
						width: 2.45rem;
						height: 2.05rem;
				}
			}
			.course-name{
				margin: 0.75rem 0.9rem 0.6rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.2rem;
				color: #1D1D1D;
				line-height: 1rem;
			}
			.course-text{
				margin: 0 0.9rem 0.5rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 0.8rem;
				color: #74798C;
				line-height: 1rem;
				height:2rem;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;
			
			}
			.course-btn{
				display: flex;
				align-items: center;
				justify-content: flex-start;
				margin: 0 0.9rem;
				.course-avator{
					width: 1.2rem;
					height: 1.2rem;
					border-radius: 6rem;
					margin-right: 0.4rem;
				}
				.course-teacher{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: #1D1D1D;
					line-height: 1.12rem;
				}
				.course-save{
					background-image: url('../assets/heart-1.png');
					background-repeat: no-repeat;
					background-size: contain;
					width: 1.2rem;
					height: 1.2rem;
					margin-left: auto;
				}
			}
		}
	}
}
</style>
